import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [academicsOpen, setAcademicsOpen] = useState(false);
  const [aboutUsOpen, setAboutUsOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const academicsItems = [
    { name: 'School Timings', path: '/academics/school-timings' },
    { name: 'Fee Structure', path: '/academics/fee-structure' },
    { name: 'Uniform Code', path: '/academics/uniform-code' },
    { name: 'Books', path: '/academics/books' },
    { name: 'Notices', path: '/#notices' },
    { name: 'Admission', path: '/academics/admission' },
    { name: 'Result', path: '/academics/result' }
  ];

  const aboutUsItems = [
    { name: 'Mission and Vision', path: '/about-us/mission-vision' },
    { name: "Principal's Message", path: '/about-us/principals-message' },
    { name: 'Faculties', path: '/about-us/faculties' },
    { name: 'General Information', path: '/about-us/general-information' },
    { name: 'Bank Details', path: '/about-us/bank-details' }
  ];

  const isActive = (path) => {
    const basePath = path.split('#')[0];
    return location.pathname === basePath;
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/logo/logo.jpg" alt="Millennium Model School Logo" className="logo-image" />
        </Link>
        
        <div className="mobile-menu-icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <Link 
              to="/" 
              className={`navbar-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
          </li>

          <li 
            className="navbar-item dropdown"
            onMouseEnter={() => setAcademicsOpen(true)}
            onMouseLeave={() => setAcademicsOpen(false)}
            onClick={() => setAcademicsOpen(!academicsOpen)}
          >
            <span className={`navbar-link ${location.pathname.startsWith('/academics') ? 'active' : ''}`}>
              <p>Academics</p>
              <span className="dropdown-arrow">▼</span>
            </span>
            <ul className={`dropdown-menu ${academicsOpen ? 'show' : ''}`}>
              {academicsItems.map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.path}
                    className={`dropdown-item ${isActive(item.path) ? 'active' : ''}`}
                    onClick={() => {
                      setAcademicsOpen(false);
                      setMobileMenuOpen(false);
                    }}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>

          <li 
            className="navbar-item dropdown"
            onMouseEnter={() => setAboutUsOpen(true)}
            onMouseLeave={() => setAboutUsOpen(false)}
            onClick={() => setAboutUsOpen(!aboutUsOpen)}
          >
            <span className={`navbar-link ${location.pathname.startsWith('/about-us') ? 'active' : ''}`}>
              <p>About Us</p>
              <span className="dropdown-arrow">▼</span>
            </span>
            <ul className={`dropdown-menu ${aboutUsOpen ? 'show' : ''}`}>
              {aboutUsItems.map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.path}
                    className={`dropdown-item ${isActive(item.path) ? 'active' : ''}`}
                    onClick={() => {
                      setAboutUsOpen(false);
                      setMobileMenuOpen(false);
                    }}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>

          <li className="navbar-item">
            <Link 
              to="/contact-us" 
              className={`navbar-link ${isActive('/contact-us') ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;

